export default "__VITE_ASSET__DwVRRI8R__"